module.exports = __webpack_public_path__ + "static/img/indexIntroArea01.fbec001.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexIntroArea01.jpg
// module id = lw2d
// module chunks = 3